import React, { useState } from 'react';
import Table from '../../components/tables/Table';
import { getRawMaterialInventoryDetailedView } from '../../services/inventory';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { CustomCard } from '../../components/cards/CustomCard';

const RawInventoryDetailedView = ({ rawMaterial }) => {
    const [assemblyHistory, setAssemblyHistory] = useState([]);

    useEffect(() => {
        if (rawMaterial) {
            fetchAssemblyHistoryData({ query: rawMaterial.id });
        }
    }, [rawMaterial]);

    const fetchAssemblyHistoryData = async ({ query = "" }) => {
        const res = await getRawMaterialInventoryDetailedView(`${query}`);
        if (res.status === 200) {
            setAssemblyHistory(res.data);
        } else {
            toast.error(res.data);
        }
    };

    const getStatusBadge = (status) => {
        const baseClasses = "px-2 py-1 rounded-full text-xs font-medium";
        switch (status) {
            case 'active':
                return `${baseClasses} bg-green-100 text-green-800`;
            case 'inactive':
                return `${baseClasses} bg-gray-100 text-gray-800`;
            case 'completed':
                return `${baseClasses} bg-blue-100 text-blue-800`;
            case 'in_progress':
                return `${baseClasses} bg-yellow-100 text-yellow-800`;
            case 'assembled':
                return `${baseClasses} bg-purple-100 text-purple-800`;
            default:
                return `${baseClasses} bg-gray-100 text-gray-800`;
        }
    };

    return (
        <div className="grid grid-cols-1 gap-6">
            {
                rawMaterial && <CustomCard>
                    <h3 className="text-xl font-bold mb-2">{rawMaterial.name}</h3>
                    <div className="mb-4 text-sm text-gray-600">
                        <div className="mb-1"><span className="font-semibold">SKU:</span> {rawMaterial.sku}</div>
                        <div className="mb-1"><span className="font-semibold">Category:</span> {rawMaterial.category}</div>
                        <div className="mb-2"><span className="font-semibold">Description:</span> {rawMaterial.description}</div>
                    </div>
                    <div className="mb-4">
                        <div className="flex flex-col gap-1">
                            <div><span className="font-semibold">Current Stock:</span> {rawMaterial.quantity} {rawMaterial.unit}</div>
                            <div><span className="font-semibold">Threshold:</span> {rawMaterial.threshold} {rawMaterial.unit}</div>
                            <div><span className="font-semibold">Created By:</span> {rawMaterial.raw_material_created_by}</div>
                        </div>
                    </div>
                    {rawMaterial.last_raw_material_transaction && (
                        <div className="bg-gray-50 rounded p-3 mt-2 border">
                            <div className="font-semibold mb-2 text-gray-700">Last Transaction</div>
                            <div className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
                                <div><span className="font-semibold">Quantity:</span> {rawMaterial.last_raw_material_transaction.quantity} {rawMaterial.last_raw_material_transaction.unit}</div>
                                <div><span className="font-semibold">Price:</span> ₹{rawMaterial.last_raw_material_transaction.price}</div>
                                <div><span className="font-semibold">Supplier:</span> {rawMaterial.last_raw_material_transaction.supplier}</div>
                                <div><span className="font-semibold">Location:</span> {rawMaterial.last_raw_material_transaction.location}</div>
                                <div><span className="font-semibold">Added By:</span> {rawMaterial.last_raw_material_transaction.added_by}</div>
                                <div><span className="font-semibold">Date:</span> {new Date(rawMaterial.last_raw_material_transaction.created_at).toLocaleString()}</div>
                            </div>
                        </div>
                    )}
                </CustomCard>}

            <CustomCard title="Recent Assembly Activity">
                <Table
                    headers={[
                        { label: "Quantity", key: "quantity" },
                        { label: "Price", key: "price" },
                        { label: "Supplier", key: "supplier" },
                        { label: "Location", key: "location" },
                        { label: "Added By", key: "added_by" },
                        { label: "Date & Time", key: "date" },
                        { label: "Status", key: "status" }
                    ]}
                    rows={assemblyHistory.results?.map((activity) => ({
                        quantity: <span className="font-semibold">{activity.quantity} {activity.unit}</span>,
                        price: <span className="font-semibold">₹{activity.price}</span>,
                        supplier: <span className="font-semibold">{activity.supplier}</span>,
                        location: <span className="font-semibold">{activity.location}</span>,
                        added_by: activity.added_by,
                        date: new Date(activity.created_at).toLocaleString(),
                        status: (
                            <span className={getStatusBadge(activity.status)}>
                                {activity.status ? activity.status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) : 'N/A'}
                            </span>
                        )
                    }))}
                />
            </CustomCard>
        </div>
    );
};

export default RawInventoryDetailedView; 